module.exports = __webpack_public_path__ + "img/mulher_a_vontade.25efebd5.png";